import { render } from "./pagetree.vue?vue&type=template&id=4f29a8ca&scoped=true"
import script from "./pagetree.vue?vue&type=script&lang=js"
export * from "./pagetree.vue?vue&type=script&lang=js"

import "./pagetree.vue?vue&type=style&index=0&id=4f29a8ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f29a8ca"]])

export default __exports__